/**
 * R3 — решение гарда «принудительная смена пароля» в виде чистой функции (тестируемо
 * без поднятия всего роутера). Когда у пользователя must_change_password=true, любой
 * переход (кроме /settings и публичных) блокируется и уводит на форму смены пароля.
 * R3: блокировку сопровождаем явным toast'ом (а не молчаливым редиректом — оператор
 * видел «мёртвый» клик по меню без объяснения). Toast показываем только при РЕАЛЬНОМ
 * переходе на другой путь (from ≠ to), иначе спамил бы на каждый guard-eval.
 */
export interface MustChangeAuth {
  isAuthenticated: boolean;
  user?: { must_change_password?: boolean } | null;
}

export function mustChangePasswordDecision(
  to: { path: string; meta: { publicOnly?: boolean } },
  from: { path: string },
  auth: MustChangeAuth,
): { redirect: boolean; toast: boolean } {
  const blocked =
    auth.isAuthenticated &&
    auth.user?.must_change_password === true &&
    to.path !== "/settings" &&
    !to.meta.publicOnly;
  if (!blocked) return { redirect: false, toast: false };
  return { redirect: true, toast: from.path !== to.path };
}
